import React, { useState, useEffect } from "react";



import { useNavigate, Link, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import db from "./Firebase";
import { collection, doc, updateDoc, onSnapshot, orderBy, getDoc, where, getDocs, addDoc, Timestamp, query } from "firebase/firestore";
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import { Button, Form } from "react-bootstrap";

function RequestedTopics() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchType, setSearchType] = useState(""); // State for filtering by type
    const navigate = useNavigate();
    const [email, setEmail] = useState("");

    useEffect(() => {
        const storedUsername = localStorage.getItem("email");
        const storedPassword = localStorage.getItem("password");
        const storedRemember = localStorage.getItem("remember");

        setEmail(storedUsername)

        if (storedRemember === "false" || !storedUsername || !storedPassword) {
            navigate('/signin');
        }

    }, []);


    useEffect(() => {
        const q = query(collection(db, "nv_requested_topics"), orderBy("created_date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data(),
                }))
            );
        });

        return () => unsubscribe();
    }, []);


    const handleAddRemark = async (id, remark) => {
        try {
            const queryRef = doc(db, "nv_faqs_query", id);
            await updateDoc(queryRef, { remarks: [...(data.find(d => d.id === id).data.remarks || []), remark] });

            Swal.fire("Added!", "Remark has been added.", "success");
        } catch (error) {
            console.error("Error adding remark:", error);
            Swal.fire("Error!", "Could not add remark.", "error");
        }

        // ✅ Add log entry in "nv_backend_logs"
        const logEntry = {
            created_date: new Date(), // Current timestamp
            email: email || "unknown", // Fallback if email is missing
            page: "FaqsQuery",
            action: `Added remark: ${remark} to query ID: ${id}`,
        };

        await addDoc(collection(db, "nv_backend_logs"), logEntry);
        console.log("Log entry added:", logEntry);
    };


    const handleStatusChange = async (id, newStatus, issueQuery, phone) => {
        // try {
        //     // **Update Firestore with the selected status**
        //     const queryRef = doc(db, "nv_faqs_query", id);
        //     await updateDoc(queryRef, { status: newStatus });

        //     // **Fetch username from personal_details**
        //     const userQuery = query(collection(db, "personal_details"), where("phone_no", "==", phone));
        //     const querySnapshot = await getDocs(userQuery);

        //     if (querySnapshot.empty) {
        //         Swal.fire("Error!", "User not found!", "error");
        //         return;
        //     }

        //     let username = "";
        //     querySnapshot.forEach((doc) => {
        //         username = doc.data().username; // Extract username
        //     });

        //     // **Send notification only if marked as Resolved (1)**
        //     if (newStatus === 1) {
        //         await addDoc(collection(db, "nv_notifications"), {
        //             actions: false,
        //             category: "Alert",
        //             created_at: new Date(),
        //             image: "",
        //             is_download: "",
        //             is_join: "",
        //             redirect_page: "",
        //             requested_phone_no: phone,
        //             requested_user: username,
        //             seen_by: [],
        //             status: "1",
        //             timestamp: new Date(),
        //             title: `Your issue "${issueQuery}" has been resolved. Thank you for your patience!`,
        //             type: "private",
        //             user_id: username,
        //             id: new Date().getTime() + new Date().getMilliseconds(),
        //         });

        //         Swal.fire("Resolved!", "The issue has been marked as resolved.", "success");
        //     }

        //     // **Update UI Immediately**
        //     setData((prevData) =>
        //         prevData.map((record) =>
        //             record.id === id ? { ...record, data: { ...record.data, status: newStatus } } : record
        //         )
        //     );
        // } catch (error) {
        //     console.error("Error updating status:", error);
        //     Swal.fire("Error!", "Something went wrong. Please try again.", "error");
        // }

        // // ✅ Add log entry in "nv_backend_logs"
        // const logEntry = {
        //     created_date: new Date(), // Current timestamp
        //     email: email || "unknown", // Fallback if email is missing
        //     page: "FaqsQuery",
        //     action: `Status changed to: ${newStatus === 1 ? "Resolved" : newStatus === 2 ? "Call not connected" : "Pending"} for query ID: ${id}`,
        // };

        // await addDoc(collection(db, "nv_backend_logs"), logEntry);
        // console.log("Log entry added:", logEntry);
    };



    const filteredData = data.filter((record) => {
        const phoneNo = record.data.phone_no || ""; // Default to empty string if undefined
        const fullName = record.data.full_name || ""; // Default to empty string if undefined

        const matchesPhone = phoneNo.includes(searchQuery);
        const matchesType = searchType === "" || fullName.toLowerCase().includes(searchType.toLowerCase());

        return matchesPhone && matchesType;
    });

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3 mb-2">
                    <h6 className="mb-2">Requested Topics - (Count: {filteredData.length})</h6>
                </div>

                {/* Search Inputs */}
                <div className="mb-3 d-flex gap-2">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search by phone no..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ width: "250px" }}
                    />

                    <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Search by name..."
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={{ width: "250px" }}
                    />
                </div>

                {/* Table */}
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                {/* <th>Is Helpful</th>
                                <th>Question</th> */}
                                <th>Message</th>
                                <th>Created Date</th>
                                {/* <th style={{ minWidth: "200px" }}>Status</th>
                                <th>Remarks</th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map(({ id, data }, index) => (
                                <tr key={id}>
                                    <td>{index + 1}</td>
                                    <td>{data.full_name}</td>
                                    <td>{data.phone_no}</td>
                                    {/* <td>{data.is_helpful}</td>
                                    <td>{data.question}</td> */}
                                    <td>{data.message}</td>
                                    <td>
                                        {data.created_date
                                            ? moment(
                                                data.created_date.toDate
                                                    ? data.created_date.toDate()
                                                    : data.created_date
                                            ).format("DD/MM/YY, h:mm a")
                                            : "N/A"}
                                    </td>
                                    {/* <td>
                                        <Form.Select
                                            value={data.status}
                                            onChange={(e) => handleStatusChange(id, parseInt(e.target.value), data.question, data.phone_no)}
                                        >
                                            <option value="0">Pending</option>
                                            <option value="1">Resolved</option>
                                            <option value="2">Call not connected</option>
                                        </Form.Select>
                                    </td> */}


                                    {/* <td>
                                        <Form.Control
                                            type="text"
                                            placeholder="Add a remark"
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    handleAddRemark(id, e.target.value);
                                                    e.target.value = "";
                                                }
                                            }}
                                        />
                                        <ul>
                                            {(data.remarks || []).slice().reverse().map((remark, i) => (
                                                <li key={i}>{remark}</li>
                                            ))}
                                        </ul>
                                    </td> */}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default RequestedTopics;

